<template>
  <div class="login-container">
    <div class="info">
      <!-- 左侧图 -->
      <div class="textInfo" style="position: relative; overflow: hidden;">
        <div class="textInfo1">
          <h1 v-if="!xinyou">LearnOnly学习本●教学常态评估系统</h1>
          <h1 v-if="xinyou">新优学习本●教学常态评估系统</h1>
          <p>护眼墨水屏 | 媲美原生纸笔 | 校本题库 | 学情分析 | 校本阅读</p>
        </div>
      </div>
      <!-- 右侧登录 -->
      <div class="login">
        <div class="loginInfo">
          <div class="logo">
            <img v-if="!xinyou" src="../assets/images/logo-big.png" />
            <img v-if="xinyou" src="../assets/images/xinyou-1.png" />
          </div>

          <div class="login_choice">
            <span @click="showNormalLogin(0)">账号密码登录</span>
            <span @click="showWeixinLogin(1)">
              <img src="../assets/images/weixinicon.png" width="24" />微信扫码登录
            </span>
            <span @click="showDingdingLogin(2)">
              <img src="../assets/images/dingdingicon.png" width="24" />钉钉扫码登录
            </span>
          </div>

          <div id="normal_login_container" class="login_container">
            <a-form id="login" class="login-form" :form="form" @submit="login">
              <a-form-item>
                <a-input
                  v-decorator="[
                  'username',
                  {
                    rules: [{ required: true, message: '请输入账号!' }],
                    initialValue: '',
                  },
                ]"
                  placeholder="请输入账号"
                >
                  <a-icon slot="prefix" type="user" style="color: rgba(69,140,252)" />
                </a-input>
              </a-form-item>

              <a-form-item>
                <a-input
                  v-decorator="[
                  'password',
                  {
                    rules: [{ required: true, message: '请输入密码!' }],
                    initialValue: '',
                  },
                ]"
                  type="password"
                  placeholder="请输入密码"
                >
                  <a-icon slot="prefix" type="lock" style="color: rgba(69,140,252)" />
                </a-input>
              </a-form-item>

              <a-form-item>
                <a-checkbox
                  v-decorator="[
                  'remember',
                  { valuePropName: 'checked', initialValue: true },
                ]"
                  style="margin-bottom:5px;"
                >自动登录</a-checkbox>

                <a class="login-form-forgot" href>忘记密码</a>

                <a-button
                  v-if="!xinyou"
                  type="primary"
                  html-type="submit"
                  :loading="loading"
                  style="background: #458cfc;"
                >登 录</a-button>
                <a-button
                  v-if="xinyou"
                  type="primary"
                  html-type="submit"
                  :loading="loading"
                  style="background: #184b69;"
                >登 录</a-button>

                <div style="text-align:center;width:100%;">
                  <span>
                    <a @click="goto_tianli_login()">天立集团用户点此处登录</a>
                  </span>
                </div>
              </a-form-item>
            </a-form>
          </div>
          <div
            id="weixin_login_container"
            class="login_container"
            style="padding-left:20px;padding-top:5px;"
          >
            <div id="weixin_login_container_iframe"></div>
            <div></div>
          </div>
          <div id="dingding_login_container" class="login_container">
            <div id="dingding_login_containter_iframe"></div>
            <div style="text-align:center;padding-top:12px;">
              <p
                style="font-size:13px;line-height:10px;font-weight:400;font-family:Microsoft Yahei;"
              >使用钉钉扫一扫登录</p>
              <p
                style="font-size:13px;line-height:10px;font-weight:400;font-family:Microsoft Yahei;"
              >"LearnOnly教师端"</p>
            </div>
          </div>
        </div>
        <div class="footer">
          <div v-if="!xinyou">
            Copyright© 2018-{{currYear}} 全勾教育 版权所有
            <br />
            <a href="https://beian.miit.gov.cn/" target="_blank">沪ICP备18017950号-3</a>
            &nbsp;&nbsp;
            <a
              href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010702006453"
              target="_blank"
            >沪公网安备31010702006453号</a>
            <br />
            <a
              href="https://app.eduyun.cn/bmp-web/mapp/appRecordList"
              target="_blank"
            >教育部APP备3100124 / 3100125 / 3100126号</a>
          </div>
          <div v-if="xinyou">
            运营管理 © 新优教育
            <a href="http://beian.miit.gov.cn" target="_blank">吉ICP备18001708号</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import fetch from '@/utils/http'
import loadJs from '@/assets/js/loadJs.js'
export default {
  data () {
    return {
      redirect: "",
      loading: false,
      xinyou: false,
      currYear: new Date().getFullYear()
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this)
  },
  methods: {

    //点击链接跳转到天立系统的登录界面--》permission.js/url拦截处理自动登录
    goto_tianli_login () {
      var career = 1//教师登录
      var callback = window.location.href.split("/login")[0] + "/login"
      var params = {
        career: career,
        callback: callback,
      }

      this.$http.post('/v1/user/login/tianli/getLoginParmas', params).then(response => {
        if (response.data.code === 200) {
          var data = response.data.data
          window.location.href = data.url + "/#/thirdLogin?appid=" + data.appid +
            "&login_type=" + career + "&redirect_url=" + callback +
            "&timestamp=" + data.timestamp + "&sign=" + data.sign
        }
      })
    },


    //普通输账号密码点确定按钮登录--》user.js/login()
    login (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true
          this.$store
            .dispatch("login", values)
            .then(() => {
              if (this.$store.getters.token) {
                this.$message.success("登录成功")
              } else {
                this.$message.error(this.$store.getters.message)
              }
              this.loading = false
              this.$router.push({ path: "/" })
            })
            .catch((message) => {
              this.loading = false
            })
        }
      })
    },





    //显示普通账号密码登录界面
    showNormalLogin (orderIndex) {
      $(".login_container").hide()
      $("#normal_login_container").show()
      $(".login_choice span").removeClass()
      $(".login_choice span").eq(orderIndex).addClass("current")
    },

    //显示微信扫码登录界面 onlyloadDontDisplay == true 只是预先加载二维码但不显示
    showWeixinLogin (orderIndex, onlyloadDontDisplay) {
      loadJs('https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js').then(() => {
        if ($("#weixin_login_container_iframe").html().length == 0) {
          var callback = window.location.href.split("/login")[0] + "/login"
          var state = "weixin"

          //callback = "https://edu-test.learnonly.com"

          new WxLogin({
            self_redirect: false,//true：手机点击确认登录后可以在 iframe 内跳转到 redirect_uri;false：手机点击确认登录后可以在 top window 跳转到 redirect_uri。默认为 false。
            id: "weixin_login_container_iframe",
            appid: "wxa8eb321b04e7dd96",//AppId
            scope: "snsapi_login",
            redirect_uri: encodeURIComponent(callback),
            state: state,//微信回调时会送回来
            style: "black",
            href: window.location.href.split("/login")[0] + "/resources/weixinlogin.css"
            //微信用独立css控制二维码样式~/resources/weixinlogin.css
          });
        }

        if (onlyloadDontDisplay) return

        this.$nextTick(() => {
          $(".login_container").hide()
          $("#weixin_login_container").show()
          $(".login_choice span").removeClass()
          $(".login_choice span").eq(orderIndex).addClass("current")
        });
      })
    },

    //显示钉钉扫码登录界面 onlyloadDontDisplay == true 只是预先加载二维码但不显示
    showDingdingLogin (orderIndex, onlyloadDontDisplay) {
      loadJs('https://g.alicdn.com/dingding/h5-dingtalk-login/0.21.0/ddlogin.js').then(() => {
        if ($("#dingding_login_containter_iframe").html().length == 0) {
          var callback = window.location.href.split("/login")[0] + "/login"
          var state = "dingding"

          //callback = "https://edu-test.learnonly.com"

          window.DTFrameLogin(
            {
              id: 'dingding_login_containter_iframe',
              width: 340,
              height: 250,
            },
            {
              redirect_uri: encodeURIComponent(callback),
              client_id: 'ding3wdve8x0ptgnvd5f',//AppKey
              scope: 'openid',
              response_type: 'code',
              state: state,//钉钉回调时会送回来
              prompt: 'consent',
            },
            (loginResult) => {
              const { redirectUrl, authCode, state } = loginResult;
              //为了保持和微信的回调参数对齐方便后续程序统一处理
              window.location.href = redirectUrl.replace("?authCode=", "?code=")
            },
            (errorMsg) => {
              this.$message.error(`Login Error: ${errorMsg}`)
            },
          );
        }

        if (onlyloadDontDisplay) return

        this.$nextTick(() => {
          $(".login_container").hide()
          $("#dingding_login_container").show()
          $(".login_choice span").removeClass()
          $(".login_choice span").eq(orderIndex).addClass("current")
        });
      })
    },

    getUrlQueryVariable (variable, defaultValue) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) { return pair[1]; }
      }
      return defaultValue;
    }

  },
  created () {
    this.xinyou = window.location.href.includes("beikezu")
  },
  mounted () {

    //默认显示哪种登录方式：普通账号密码登录、微信扫码登录、钉钉扫码登录
    let loginType = sessionStorage.getItem("logintype")
    switch (loginType) {
      default://账号密码方式登录
        this.showNormalLogin(0)
        this.showWeixinLogin(1, true)//提前加载二维码但不显示
        this.showDingdingLogin(2, true)//提前加载二维码但不显示
        break
      case "weixin"://微信二维码登录
        this.showWeixinLogin(1, false)
        break
      case "dingding"://钉钉二维码登录
        this.showDingdingLogin(2, false)
        break
    }
    sessionStorage.removeItem("logintype")

    //上次登录接口返的错误信息提示用户
    let lastErrorMsg = sessionStorage.getItem("lastErrormsg")
    if (lastErrorMsg && lastErrorMsg.length > 0) {
      this.$message.error(lastErrorMsg, 5)
      sessionStorage.removeItem("lastErrormsg")
    }

  },
  watch: {
    $route: {
      handler: function (route) {
        const query = route.query
        if (query) {
          this.redirect = query.redirect
        }
      },
      immediate: true,
    },
  },
}
</script>

<style scoped>
* {
  -webkit-touch-callout: none; /*系统默认菜单被禁用*/
  -webkit-user-select: none; /*webkit浏览器*/
  -khtml-user-select: none; /*早期浏览器*/
  -moz-user-select: none; /*火狐*/
  -ms-user-select: none; /*IE10*/
  user-select: none;

  /* 重大悼念活动黑灰化 */
  /* filter: grayscale(1);
  -webkit-filter: grayscale(1);
  -khtml-filter: grayscale(1);
  -moz-filter: grayscale(1);
  -ms-filter: grayscale(1); */
}
input {
  -webkit-user-select: auto; /*webkit浏览器*/
}

.login-container {
  height: 722px;
  /* width: 100%;
    height: 100%;
    position: fixed;
    background: url("../assets/images/login_bg.png") no-repeat;
    background-size: 100% 100%; */
}
.info {
  width: 100%;
  /* height: 100%; */
  min-height: 100vh;
  overflow: hidden;
}
.info .textInfo {
  float: left;
  width: 60%;
  /* height: 100%; */
  min-height: 100vh;
  background-image: url('../assets/images/login_bg.png');
  background-size: cover;
}
.info .textInfo1 {
  width: 90%;
  height: 100%;
  position: relative;
  overflow: hidden;
  transform: translate(10%, 22%);
}
.textInfo1 h1 {
  font-size: 40px;
  color: #fff;
  margin-top: 200px;
}
.textInfo1 h1 span {
  font-size: 38px;
  padding: 0 3px;
}
.textInfo1 p {
  font-size: 18px;
  padding: 10px 0;
  color: #fff;
}
.textInfo1 a {
  color: #fff;
  font-size: 18px;
  text-decoration: underline;
}
.info .login {
  float: right;
  width: 40%;
  /* height: 100%; */
  min-height: 100vh;
  background: #fff;
  position: relative;
}
.login .loginInfo {
  width: 340px;
  height: 450px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -200px 0 0 -170px;
}
.loginInfo .logo {
  font-size: 36px;
  text-align: center;
  width: 340px;
  margin: 0 auto 40px auto;
}
.logo img {
  width: 100%;
}

.login-form {
  width: 100%;
  margin: 0;
}

.login-form-forgot {
  float: right;
  color: #8f8f8f;
}
.footer {
  position: absolute;
  bottom: 10px;
  left: 0;
  width: 100%;
}
.footer div {
  text-align: center;
}
.ant-form-item {
  margin-bottom: 20px;
}
.ant-input-affix-wrapper {
  border: 1px solid #ddd;
  border-radius: 5px;
}
/deep/.ant-checkbox-inner {
  border: 1px solid #d9d9d9;
  background-color: none;
}
/deep/.ant-input {
  height: 40px;
  color: #a9a9a9;
  background-color: rgba(255, 255, 255, 0.2);
}
/deep/.has-error
  .ant-input-affix-wrapper:hover
  .ant-input:not(.ant-input-disabled) {
  border-color: rgba(255, 255, 255, 0.2);
}
/deep/.has-error .ant-input-affix-wrapper .ant-input,
.has-error .ant-input-affix-wrapper .ant-input:hover {
  border: 1px solid rgba(255, 255, 255, 0.1);
}
/deep/.has-error .ant-form-explain {
  color: #458cfc !important;
}
/deep/.ant-input {
  height: 40px;
  border: none;
  border-radius: 5px;
}
button {
  margin: 0 !important;
  color: #fff;
}
.ant-btn {
  line-height: 40px;
  height: 40px;
  width: 100%;
}

.login_choice {
  margin-bottom: 10px;
  width: 100%;
  text-align: center;
}

.login_choice span {
  font-weight: bold;
  color: #ccc;
  cursor: pointer;
  display: inline-block;
  margin-right: 5px;
}
.login_choice span img {
  opacity: 0.25;
}
.login_choice span:hover {
  color: #999;
}
.login_choice span:hover img {
  opacity: 0.55;
}
.login_choice span.current {
  color: #333;
}
.login_choice span.current img {
  opacity: 1;
}

.login_container {
  width: 340px;
  height: 250px;
  display: none;
}
</style>
